var _g, _g2, _g3, _g4, _g5, _g6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTokens(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 25,
    viewBox: "0 0 36 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1258_3746)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1258_3746)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 12.5C9.31371 12.5 12 9.81371 12 6.5C12 3.18629 9.31371 0.5 6 0.5C2.68629 0.5 0 3.18629 0 6.5C0 9.81371 2.68629 12.5 6 12.5Z",
    fill: "#13B5EC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.45 5.3375L7.8 4.55V6.125L6.45 5.3375ZM7.8 8.7125L6 9.7625L4.2 8.7125V6.875L6 7.925L7.8 6.875V8.7125ZM4.2 4.55L5.55 5.3375L4.2 6.125V4.55ZM6.225 5.7125L7.575 6.5L6.225 7.2875V5.7125ZM5.775 7.2875L4.425 6.5L5.775 5.7125V7.2875ZM7.575 4.175L6 5.075L4.425 4.175L6 3.2375L7.575 4.175ZM3.75 4.025V8.9375L6 10.2125L8.25 8.9375V4.025L6 2.75L3.75 4.025Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1258_3746)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_1258_3746)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 24.5C9.32502 24.5 12 21.825 12 18.5C12 15.175 9.32502 12.5 6 12.5C2.67498 12.5 0 15.175 0 18.5C0 21.825 2.67498 24.5 6 24.5Z",
    fill: "#2775CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.65 19.45C7.65 18.575 7.125 18.275 6.075 18.15C5.325 18.05 5.175 17.85 5.175 17.5C5.175 17.1499 5.42502 16.925 5.925 16.925C6.375 16.925 6.62502 17.075 6.75 17.45C6.77502 17.525 6.85002 17.575 6.92502 17.575H7.32498C7.425 17.575 7.5 17.5 7.5 17.4V17.375C7.39998 16.825 6.94998 16.4 6.375 16.35V15.75C6.375 15.65 6.3 15.575 6.17502 15.55H5.80002C5.7 15.55 5.625 15.625 5.59998 15.75V16.325C4.84998 16.425 4.37502 16.925 4.37502 17.55C4.37502 18.375 4.875 18.7 5.925 18.825C6.62502 18.95 6.85002 19.1 6.85002 19.5C6.85002 19.9 6.49998 20.175 6.02502 20.175C5.37498 20.175 5.14998 19.9 5.07498 19.525C5.05002 19.425 4.97502 19.375 4.90002 19.375H4.47498C4.37502 19.375 4.30002 19.45 4.30002 19.55V19.575C4.39998 20.2 4.8 20.65 5.625 20.775V21.375C5.625 21.475 5.7 21.55 5.82498 21.575H6.19998C6.3 21.575 6.375 21.5 6.40002 21.375V20.775C7.15002 20.65 7.65 20.125 7.65 19.45V19.45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.725 22.075C2.775 21.375 1.77498 19.2 2.50002 17.275C2.87502 16.225 3.70002 15.425 4.725 15.05C4.82502 15 4.875 14.925 4.875 14.8V14.45C4.875 14.35 4.82502 14.275 4.725 14.25C4.69998 14.25 4.65 14.25 4.62498 14.275C2.25 15.025 0.949979 17.55 1.69998 19.925C2.14998 21.325 3.225 22.4 4.62498 22.85C4.725 22.9 4.82502 22.85 4.84998 22.75C4.875 22.725 4.875 22.7 4.875 22.65V22.3C4.875 22.225 4.8 22.125 4.725 22.075ZM7.37502 14.275C7.275 14.225 7.17498 14.275 7.15002 14.375C7.125 14.4 7.125 14.425 7.125 14.475V14.825C7.125 14.925 7.2 15.025 7.275 15.075C9.225 15.775 10.225 17.95 9.49998 19.875C9.12498 20.925 8.29998 21.725 7.275 22.1C7.17498 22.15 7.125 22.225 7.125 22.35V22.7C7.125 22.8 7.17498 22.875 7.275 22.9C7.30002 22.9 7.35 22.9 7.37502 22.875C9.75 22.125 11.05 19.6 10.3 17.225C9.85002 15.8 8.74998 14.725 7.37502 14.275V14.275Z",
    fill: "white"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_1258_3746)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_1258_3746)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 12.5C21.3137 12.5 24 9.81371 24 6.5C24 3.18629 21.3137 0.5 18 0.5C14.6863 0.5 12 3.18629 12 6.5C12 9.81371 14.6863 12.5 18 12.5Z",
    fill: "#F2F4F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0928 2.23438L18.0356 2.42984V8.09891L18.0928 8.15609L20.7244 6.60078L18.0928 2.23438Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0928 2.23438L15.4612 6.60078L18.0928 8.15609V5.40453V2.23438Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0928 8.65438L18.0605 8.69422V10.7136L18.0928 10.8083L20.7262 7.10001L18.0928 8.65438Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0928 10.8083V8.65436L15.4612 7.09952L18.0928 10.8083Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0928 8.1561L20.7244 6.60079L18.0928 5.40454V8.1561Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4612 6.60079L18.0928 8.1561V5.40454L15.4612 6.60079Z",
    fill: "#393939"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_1258_3746)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7_1258_3746)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 12.5C21.3136 12.5 24 15.1864 24 18.5C24 21.8136 21.3134 24.5 18 24.5C14.6866 24.5 12 21.8143 12 18.5C12 15.1857 14.6861 12.5 18 12.5Z",
    fill: "#53AE94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7405 17.7005V16.808H20.7816V15.448H15.2237V16.808H17.265V17.6998C15.606 17.776 14.3586 18.1046 14.3586 18.4982C14.3586 18.8918 15.6066 19.2203 17.265 19.297V22.156H18.741V19.2968C20.397 19.2203 21.6419 18.892 21.6419 18.4988C21.6419 18.1055 20.397 17.7772 18.741 17.7008M18.741 19.0546V19.0539C18.6994 19.0565 18.4854 19.0694 18.009 19.0694C17.6281 19.0694 17.3602 19.0586 17.2657 19.0537V19.0549C15.8001 18.9899 14.706 18.7347 14.706 18.4293C14.706 18.1239 15.8002 17.869 17.2657 17.804V18.8006C17.3617 18.8072 17.6363 18.8234 18.0153 18.8234C18.4704 18.8234 18.6993 18.8044 18.7413 18.8006V17.804C20.2041 17.8691 21.2956 18.1246 21.2956 18.4289C21.2956 18.7333 20.2036 18.9889 18.7413 19.054",
    fill: "white"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip8_1258_3746)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip9_1258_3746)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.8198 7.95143C35.0185 11.1657 31.7629 13.1219 28.5482 12.3204C25.3348 11.519 23.3787 8.26324 24.1804 5.04918C24.9814 1.83451 28.2369 -0.121803 31.4506 0.67954C34.6651 1.48088 36.6212 4.73702 35.8197 7.95149L35.8198 7.95143H35.8198Z",
    fill: "#F7931A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6457 5.64514C32.7652 4.84667 32.1573 4.41746 31.326 4.13114L31.5957 3.04954L30.9373 2.88548L30.6748 3.9386C30.5017 3.89543 30.3239 3.85475 30.1472 3.81443L30.4117 2.75436L29.7537 2.5903L29.4839 3.67155C29.3406 3.63893 29.1999 3.6067 29.0634 3.57274L29.0642 3.56934L28.1563 3.34261L27.9811 4.04582C27.9811 4.04582 28.4696 4.15779 28.4593 4.16469C28.7259 4.23123 28.7741 4.40772 28.7661 4.54762L28.4589 5.77981C28.4773 5.78447 28.5011 5.79122 28.5274 5.80177C28.5054 5.79632 28.4821 5.79037 28.4578 5.78456L28.0272 7.51068C27.9947 7.59169 27.912 7.71325 27.7256 7.66709C27.7322 7.67665 27.247 7.54767 27.247 7.54767L26.9201 8.30132L27.7769 8.51491C27.9363 8.55489 28.0925 8.59671 28.2464 8.63604L27.9739 9.73004L28.6315 9.8941L28.9014 8.81171C29.081 8.86048 29.2554 8.90547 29.426 8.94788L29.1571 10.0252L29.8156 10.1892L30.088 9.09727C31.2107 9.30975 32.0549 9.22408 32.4102 8.20859C32.6966 7.391 32.396 6.91941 31.8053 6.61189C32.2355 6.51267 32.5596 6.22972 32.646 5.64522L32.6458 5.64508L32.6457 5.64514ZM31.1414 7.75454C30.938 8.57213 29.5614 8.13017 29.1151 8.01934L29.4766 6.56998C29.9229 6.68139 31.3541 6.90188 31.1415 7.75454H31.1414ZM31.3451 5.63329C31.1594 6.37697 30.0137 5.99915 29.642 5.9065L29.9698 4.59202C30.3415 4.68466 31.5384 4.85758 31.3451 5.63329H31.3451Z",
    fill: "white"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip10_1258_3746)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip11_1258_3746)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 12.5C33.314 12.5 36 15.1865 36 18.5C36 21.814 33.314 24.5 30 24.5C26.6865 24.5 24 21.8137 24 18.5C24 15.1865 26.6865 12.5 30 12.5Z",
    fill: "#F5AC37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2211 18.9236H32.501C32.5496 18.9236 32.5726 18.9236 32.5761 18.8599C32.5947 18.628 32.5947 18.3947 32.5761 18.1625C32.5761 18.1174 32.5537 18.0988 32.5048 18.0988H27.9674C27.9113 18.0988 27.8961 18.1174 27.8961 18.17V18.8375C27.8961 18.9236 27.8961 18.9236 27.986 18.9236H30.2211V18.9236ZM32.3215 17.3187C32.328 17.3017 32.328 17.2831 32.3215 17.2663C32.2834 17.1835 32.2383 17.1043 32.1859 17.0301C32.1071 16.9032 32.0142 16.7863 31.9084 16.6813C31.8584 16.6178 31.8006 16.5608 31.7358 16.5125C31.4113 16.2363 31.0255 16.0408 30.6107 15.9425C30.4015 15.8955 30.1876 15.8731 29.9733 15.875H27.9596C27.9034 15.875 27.8959 15.8974 27.8959 15.9463V17.2774C27.8959 17.3336 27.8959 17.3487 27.9671 17.3487H32.2945C32.2945 17.3487 32.332 17.3411 32.3396 17.3187H32.3212H32.3215ZM32.3215 19.7037C32.2578 19.6966 32.1935 19.6966 32.1298 19.7037H27.9712C27.915 19.7037 27.8961 19.7037 27.8961 19.7787V21.0801C27.8961 21.1401 27.8961 21.1552 27.9712 21.1552H29.8912C29.983 21.1622 30.0748 21.1557 30.1647 21.1366C30.4433 21.1166 30.7174 21.0561 30.9788 20.9565C31.0738 20.9235 31.1656 20.8806 31.2523 20.829H31.2785C31.7286 20.5949 32.0941 20.2272 32.3247 19.7758C32.3247 19.7758 32.3509 19.7191 32.3215 19.7042V19.7037ZM27.1426 21.8299V21.8075V20.9338V20.6376V19.7563C27.1426 19.7074 27.1426 19.7002 27.0826 19.7002H26.2688C26.2237 19.7002 26.2051 19.7002 26.2051 19.6402V18.9277H27.0751C27.1237 18.9277 27.1426 18.9277 27.1426 18.864V18.159C27.1426 18.1139 27.1426 18.1028 27.0826 18.1028H26.2688C26.2237 18.1028 26.2051 18.1028 26.2051 18.0429V17.383C26.2051 17.3417 26.2051 17.3306 26.265 17.3306H27.0713C27.1274 17.3306 27.1426 17.3306 27.1426 17.2593V15.2381C27.1426 15.1781 27.1426 15.163 27.2176 15.163H30.03C30.2341 15.1711 30.4369 15.1935 30.6375 15.2305C31.0508 15.3069 31.448 15.4546 31.8112 15.6655C32.052 15.8073 32.2737 15.9784 32.4711 16.1755C32.6196 16.3297 32.7535 16.4966 32.8723 16.6742C32.9903 16.8543 33.0883 17.0468 33.1652 17.248C33.1747 17.3004 33.2249 17.3357 33.2773 17.3268H33.9485C34.0346 17.3268 34.0346 17.3268 34.0384 17.4094V18.0245C34.0384 18.0845 34.016 18.0996 33.9558 18.0996H33.4382C33.3858 18.0996 33.3707 18.0996 33.3745 18.1671C33.395 18.3955 33.395 18.6247 33.3745 18.8532C33.3745 18.9169 33.3745 18.9244 33.446 18.9244H34.0382C34.0643 18.9582 34.0382 18.9919 34.0382 19.026C34.0419 19.0694 34.0419 19.1134 34.0382 19.1569V19.6108C34.0382 19.6745 34.0195 19.6934 33.9631 19.6934H33.2543C33.2049 19.684 33.1569 19.7155 33.1455 19.7647C32.9768 20.2034 32.7068 20.5968 32.3579 20.9122C32.2305 21.0269 32.0966 21.1349 31.9567 21.2346C31.8066 21.321 31.6605 21.4109 31.5066 21.4822C31.2234 21.6096 30.9264 21.7036 30.6215 21.7632C30.3321 21.8151 30.0386 21.8386 29.744 21.8345H27.1415V21.8307L27.1426 21.8299Z",
    fill: "#FEFEFD"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1258_3746"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1258_3746"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1258_3746"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0 12.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_1258_3746"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0 12.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_1258_3746"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(12 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_1258_3746"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(12 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_1258_3746"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(12 12.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7_1258_3746"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(12 12.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8_1258_3746"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(24 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9_1258_3746"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(24 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10_1258_3746"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(24 12.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip11_1258_3746"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(24 12.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokens);
export default __webpack_public_path__ + "static/media/tokens.31ca4ebf89fefc05fad0c17f1df6702f.svg";
export { ForwardRef as ReactComponent };